import React from 'react';
import {timeAgo, getHostname} from './util'

const StoryBox = ({ story, rightSide }) => {
    return story ? (
        <div key={story.id} className='story-item flex justify-between items-center gap-5 py-2'>
            <div className="flex flex-col text-left justify-center gap-2 pl-3">   
            <div className='text-[.8em] flex items-center gap-2'>
                <i className="fa-solid fa-user mb-[-1px]"></i> 
                <span>{story.by}</span>
                <i className="fa-regular fa-clock mb-[-1px] pl-[10px]"></i>
                <span>{timeAgo(story.time)}</span>
            </div>
            <a className={`text-1xl text-left font-bold  pl-3`} href={story.url} target="_blank" rel="noopener noreferrer">
                {story.title}
            </a>
            <a href={story.url} className='text-[0.6em]' style={{color: '#61dafb'}}>
                {getHostname(story.url)}
            </a>
            
            </div>
            {rightSide}
        </div>
    ) : null
};

export default StoryBox;